import dayjs from 'helpers/dayjs';
import BaseItemInterface from 'interfaces/base-item.interface';

interface ExtendedBaseItemInterface extends BaseItemInterface {
    isRanking?: boolean;
}

export const CUSTOM_TOP_DATA: ExtendedBaseItemInterface[] = [
    {
        url: 'https://www.skapiec.pl/radzi',
        image: '',
        target: '_blank',
        title: 'Skąpiec radzi',
        isRanking: false
    },
    {
        url: 'https://www.skapiec.pl/radzi/poradniki',
        image: '',
        target: '_blank',
        title: 'Poradniki',
        isRanking: false
    },
    {
        url: 'https://news.skapiec.pl/',
        image: '',
        target: '_blank',
        title: 'News',
        isRanking: false
    },
    {
        url: 'https://www.skapiec.pl/cat/2744-smartwatch/ranking.html',
        image: '',
        target: '_blank',
        title: `Ranking Smartwatchy ${dayjs().year()}`,
        isRanking: true
    }
];
